<template>
  <div class="dialog-start" >

    <b-tabs content-class="m-5" fill class="mt-3">

      <b-tab title="Continue dialog">
        <b-form @submit.prevent="continueDialog" >
          <b-form-group
            id="dialog"
            label="Dialog ID"
            label-for="dialog"
            :invalid-feedback="invalidDialogID"
            :state="stateD"
          >
            <b-form-input id="dialog-id" v-model="dialogId" name="dialogId" :state="stateD" trim autocomplete="off"></b-form-input>
          </b-form-group>

          <b-button variant="primary" v-on:click.prevent="continueDialog" class="mb-3">
              Continue dialogue
          </b-button>
        </b-form>

        <b-card v-for="dialog in dialogsSorted" :key="dialog.dialogueId"
          variant="warning" class="mt-3"
          >
            <b-row>
              <b-col>
                <dt>Communication partners</dt>
                <dd>{{dialog.participants[0].personName}} | {{dialog.participants[1].personName}}</dd>
              </b-col>
              <b-col>
              <dt>Start</dt>
              <dd>{{dialog.startTime | moment("DD. MMM YYYY // HH:mm")}}</dd>
              </b-col>
              <b-col>
              <dt>Channel</dt>
              <dd>{{dialog.channel}}</dd>
              </b-col>
            </b-row>

            <b-button class="float-right" @click="continueSelectedDialog(dialog.dialogueId)">Continue dialogue</b-button>
          </b-card>
      </b-tab>

      <b-tab title="Start new dialog" @click.prevent="start">
      </b-tab>
  </b-tabs>

  </div>
</template>

<script>
var _ = require('lodash');

export default {
  name: 'DialogParticipants',
  data () {
    return {
        dialogId: '',
    }
  },
  methods: {
    start () {
      this.$store.dispatch('startDialog');
    },
    continueDialog () {
      if( this.dialogId ) {
        this.$store.dispatch('getDialogByID', {'dialogId': this.dialogId });
      }
    },
    continueSelectedDialog (selected) {
      if( selected ) {
        this.$store.dispatch('getDialogByID', {'dialogId': selected });
      }
    }

  },
  computed: {
    invalidDialogID() {
      if (this.dialogId.length >= 2) {
        return ''
      } else {
        return 'Please enter the dialog ID'
      }
    },
    stateD() {
        return this.dialogId.length >= 2 ? true : false
    },
    dialogs() {
      return this.$store.state.dialogs;
    },
    dialogsSorted() {
      return _.orderBy(this.$store.state.dialogs, 'startTime', 'desc');
    }
  }
}
</script>

<style scoped>
</style>
